import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdmirCommonService {

  constructor(
    protected db: AngularFirestore,
  ) { }

  getDateToday(): Date {

    return new Date();
  }

  getWprById(id: string, target: string): any {

    return this.db.collection(target).doc(id).valueChanges();

  }

  addWpr(target: string, siteId: string, data: any) {

    return this.db.collection(target).doc(siteId).set(data);

  }


  getWprById$(id: string, target: string): Observable<any> {

    return this.db.collection(target).doc(id)
      .snapshotChanges()
      .pipe(
        map((pageData) => {
          const data = pageData.payload.data() as any;
          const id = pageData.payload.id;
          return { id, ...data };
        })
      );

  }

  checkValidWeekdaysForToday(entityWithWeekdays: any, today: any) {
    console.log('entityWithWeekdays', entityWithWeekdays);
    // Poss but need to check support in other browsers
    // let current = new Date();
    // let today = current.toLocaleDateString('en-GB', { weekday: 'long' });
    // console.log(today);

    const weekDays = entityWithWeekdays.weekDays;
    const value = Object.values(weekDays);


    // If today is set to true we can include in signage.
    const keys = Object.keys(weekDays).filter((key) => weekDays[key] === true);

    return keys.includes(today);
  }

  checkValidDayTimesForHour(entityWithWeekdays: any, hour: any) {

    const dayTimes = entityWithWeekdays.dayTimes;
    const value = Object.values(dayTimes);
    // console.log("value", value)

    // If hour is set to true we can include in signage.
    const keys = Object.keys(dayTimes).filter((key) => dayTimes[key] === true);
    return keys.includes(hour);
  }

  checkValidForBranch(entityWithWeekdays: any, siteIdToCheck: any) {


    let found = false;
    [...entityWithWeekdays.atSites].forEach((siteId: string) => {

      if (siteId === siteIdToCheck || siteId === '*') {
        found = true;
      }
    });

    return found;

  }

  calcFireStoreDate(firebaseDate: any): Date {

    const ret =
      new Date(new Date(firebaseDate.seconds * 1000).getFullYear(),
        new Date(firebaseDate.seconds * 1000).getMonth(),
        new Date(firebaseDate.seconds * 1000).getDate(),
        new Date(firebaseDate.seconds * 1000).getHours(),
        new Date(firebaseDate.seconds * 1000).getMinutes(),
        new Date(firebaseDate.seconds * 1000).getSeconds(),
      );
    return ret;
  }

  getTimeFromMilliseconds(milliseconds: any) {

    const hours = milliseconds / (1000 * 60 * 60);
    const absoluteHours = Math.floor(hours);
    const h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

    const minutes = (hours - absoluteHours) * 60;
    const absoluteMinutes = Math.floor(minutes);
    const m = absoluteMinutes > 9 ? absoluteMinutes : '0' + absoluteMinutes;

    const seconds = (minutes - absoluteMinutes) * 60;
    const absoluteSeconds = Math.floor(seconds);
    const s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

    return h == '00' ? m + ':' + s : h + ':' + m + ':' + s;
  }

  getDistanceFromLatLon(lat1: any, lon1: any, lat2: any, lon2: any, units: any) {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
      ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    if (units == 'K') {
      const d = R * c;
      return d;
    }
    else if (units == 'M') {
      const d = (R * c) / 1.609;
      return d;
    } else {
      return 0;
    }

  }

  getDistanceFromLatLonInKm(lat1: any, lon1: any, lat2: any, lon2: any) {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
      ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }

  private deg2rad(deg: any) {
    return deg * (Math.PI / 180);
  }

  getVeganPrefs() {

    let veganPrefs = window.localStorage.getItem('veganPrefs');

    if (veganPrefs === null || veganPrefs === undefined) {
      const veganism = { id: 'a' };

      window.localStorage.setItem('veganPrefs', JSON.stringify(veganism));
      veganPrefs = window.localStorage.getItem('veganPrefs');
    }

    return (veganPrefs !== null) ? JSON.parse(veganPrefs) : null;

  }

  getCaloriePrefs() {

    let caloriePrefs = window.localStorage.getItem('caloriePrefs');

    if (caloriePrefs === null || caloriePrefs === undefined) {
      const cals = { id: 10000 };

      window.localStorage.setItem('caloriePrefs', JSON.stringify(cals));
      caloriePrefs = window.localStorage.getItem('caloriePrefs');
    }

    return (caloriePrefs !== null) ? JSON.parse(caloriePrefs) : null;


  }
}
